import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'

@Component
export default class examPage extends Vue {
  @Prop() id!: any
  @Prop() examType!: any  // exam、practice  试卷类型
  @Prop() renderType!: any  // exam、analysis  渲染类型
  @Prop() curSubId!: any  // 查看某道题的解析的 题目id
  @Prop() subType!: any
  @Prop() contentId!: any
  @Prop() contentType!: any
  @Prop() source!: any
  get examList() {
    return this.$store.state.exam.examList
  }
  get curSubjectInfo() {
    return this.$store.state.exam.curSubjectInfo
  }
  get allCardList() {
    return this.$store.state.exam.allCardList
  }
}
